export class TreelistChange {
  columnKey: string;
  rowKey: string;
  value: boolean;

  constructor(init?: Partial<TreelistChange>) {
    Object.assign(this, init);
  }
}
